import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
// import ForgotPassword from "../user-forms/ForgotPassword";
import Login from "../user-forms/Login";
import ResetPassword from "../user-forms/ResetPassword";
import Verify from "../user-forms/Verify";
import { AuthContext } from "../../context/AuthContext";
import Dashboard from "../dashboard/Dashboard";
import { Box } from "@mui/material";
import LoginOTPVarify from "../user-forms/LoginOTPVarify";
import ForgotPassword from "../user-forms/ForgotPassword";
import UserList from "../users/UserList";
import UserManagement from "../users/UserManagement";
import ExpenseCategoryList from "../expense-category/ExpenseCategoryList";
import ExpenseList from "../expense/ExpenseList";
import DepositList from "../deposit/DepositList";
import LoanList from "../loan/LoanList";
import InvestmentList from "../investment/InvestmentList";

// import NoMatch from "../NoMatch";
// import Dialog from "@mui/material/Dialog";
// import DialogContent from "@mui/material/DialogContent";
// import PulseLoader from "react-spinners/PulseLoader";
// import Country from "../country/Country";

function PrivateRoute({ children }) {
  const { login, unity_fund_admin_panel, logout } = useContext(AuthContext);
  // console.log("unity_fund_admin_panel?.data?.token", unity_fund_admin_panel);
  return unity_fund_admin_panel?.token ? children : <Navigate to="/" />;
}
function RedirectToHome({ children }) {
  const { unity_fund_admin_panel } = useContext(AuthContext);

  return !unity_fund_admin_panel?.token ? (
    children
  ) : (
    <Navigate to="/dashboard" />
  );
}
const Navigation = ({ notificationCartName }) => {
  const { unity_fund_admin_panel } = useContext(AuthContext);

  return (
    <Box>
      <Routes>
        {/* <Route path="/" element={<Projects />} />
        <Route path="project-details/:id" element={<ProjectDetails />} /> */}
        <Route
          path="/"
          element={
            <RedirectToHome>
              <Login />
            </RedirectToHome>
          }
        />
        <Route
          path="otp"
          element={
            // <PrivateRoute>
            <LoginOTPVarify />
            // </PrivateRoute>
          }
        />

        {/* <Route
          path="verify"
          element={
            <RedirectToHome>
              <Verify />
            </RedirectToHome>
          }
        /> */}
        <Route
          path="dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="user-list"
          element={
            <PrivateRoute>
              <UserList />
            </PrivateRoute>
          }
        />
        <Route
          path="expense-category-list"
          element={
            <PrivateRoute>
              <ExpenseCategoryList />
            </PrivateRoute>
          }
        />
        <Route
          path="expense-list"
          element={
            <PrivateRoute>
              <ExpenseList />
            </PrivateRoute>
          }
        />
        <Route
          path="deposit-list"
          element={
            <PrivateRoute>
              <DepositList />
            </PrivateRoute>
          }
        />
        <Route
          path="loan-list"
          element={
            <PrivateRoute>
              <LoanList />
            </PrivateRoute>
          }
        />
        <Route
          path="investment-list"
          element={
            <PrivateRoute>
              <InvestmentList />
            </PrivateRoute>
          }
        />
        <Route
          path="user-management"
          element={
            <PrivateRoute>
              <UserManagement />
            </PrivateRoute>
          }
        />

        <Route path="forgot-password" element={<ForgotPassword />} />

        <Route
          path="reset-password"
          element={
            // <PrivateRoute>
            <ResetPassword />
            // </PrivateRoute>
          }
        />

        {/* <Route
          path="*"
          element={!unity_fund_admin_panel.token ? <Navigate to="/" /> : <NoMatch />}
        /> */}
      </Routes>
    </Box>
  );
};

export default Navigation;
